import { ClipLoader } from "react-spinners";

export default function Spinner() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <ClipLoader color="#852170" size={48} />
    </div>
  );
}
